<div class="bg-img-container">
  <div class="container">
    <div class="form">
      <h2>{{ 'home.langTitle' | translate }}</h2>
      <form name="form" novalidate="" class="lang-change-form">
        <div class="col-md-4">
          <mat-label class="label-input">{{
            'home.select' | translate
          }}</mat-label>
        </div>
        <div class="col-md-8">
          <select
            class="custom-select"
            style="width: 200px; margin-top: 15px"
            (change)="changeLang($event.target.value)"
          >
            <option value="en" [selected]="lang === 'en'">English</option>
            <option value="jp" [selected]="lang === 'jp'">
              Japanese-日本語
            </option>
          </select>
        </div>
      </form>
    </div>
  </div>
</div>
